import produce from 'immer';
import * as actions from '../actions/actionTypes';
import { loadSessionStorage } from '../utils/ClientSessionHandler';

const profile = (state = initProfileStore(), action) =>
    produce(state, draft => {
        switch (action.type) {
            case actions.CHAT_HAS_ACCESSED_CHAT_ONCE:
                draft.hasAccessedChatOnce = action.hasAccessedChatOnce;
                break;
            default:
                break;
        }
    });

export const initProfileStore = () => {
    return {
        hasAccessedChatOnce: loadSessionStorage().login?.session?.extraFields?.hasAccessedChatOnce,
        hasAccessedCalendarOnce: loadSessionStorage().login?.session?.extraFields?.hasAccessedCalendarOnce,
    };
};

export default profile;
